module.exports = __webpack_public_path__ + "static/media/bg-desk-creature-6.aaf2fe40.svg";